import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAndSetData } from "../utils/getAndSetData";

export default function MaintenanceMode() {
  const dispatch = useDispatch();
  const [up, setUp] = useState(false);

  useEffect(() => {
    getAndSetData({ endpoint: "/up", method: "GET" }, setUp, dispatch);
  }, [dispatch]);

  return (
    <main style={{ height: "100vh", display: "grid", placeItems: "center" }}>
      <div>
        <h1 style={{ color: "grey", fontFamily: "Open Sans" }}>
          We are currently offline to perform scheduled maintenance
        </h1>
        <p style={{ color: "grey", fontFamily: "Open Sans" }}>
          Status: API is {up ? "up" : "down"}
        </p>
      </div>
    </main>
  );
}
